import React, {useEffect, useState} from "react";
import Sidebar from "./components/Sidebar";
import Navbar from "./components/Navbar";
import UserChartPage from "./components/UserChartPage";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const Dashboard = () => {

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem("token"); // If auth is needed
        const res = await fetch(`${baseUrl}/auth/dashboard`, {
          headers: {
            Authorization: `Bearer ${token}`, // Only if required
            "Content-Type": "application/json",
          },
        });

        const result = await res.json();
        if (res.ok && result.status) {
          setDashboardData(result.data);
        } else {
          setError(result.message || "Failed to fetch dashboard data");
        }
      } catch (err) {
        console.error(err);
        setError("Network error");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) return <div className="p-6">Loading dashboard...</div>;
  if (error) return <div className="p-6 text-red-500">{error}</div>;

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-8">
          <h3 className="text-3xl font-semibold mb-6 text-gray-800">Welcome to FF Skin and Diamonds</h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div className="p-6 bg-white text-gray-700 rounded-lg shadow-md border border-gray-200">Total Users <b className="block text-3xl mt-3 text-blue-600">{dashboardData.totalUser}</b></div>
            <div className="p-6 bg-white text-gray-700 rounded-lg shadow-md border border-gray-200">Today Created Users <b className="block text-3xl mt-3 text-blue-600">{dashboardData.todayCreatedUser}</b></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div className="p-6 bg-white text-gray-700 rounded-lg shadow-md border border-gray-200">Active Miners <b className="block text-3xl mt-3 text-green-600">{dashboardData.totalMiningActiveCount}</b></div>
            <div className="p-6 bg-white text-gray-700 rounded-lg shadow-md border border-gray-200">Inactive Miners <b className="block text-3xl mt-3 text-red-600">{dashboardData.totalMiningInactiveCount}</b></div>
            <div className="p-6 bg-white text-gray-700 rounded-lg shadow-md border border-gray-200">Total Coin Mined <b className="block text-3xl mt-3 text-blue-600">{dashboardData.totalCoinMin.toFixed(4)}</b></div>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-6 bg-white text-gray-700 rounded-lg shadow-md border border-gray-200">Today Mining <b className="block text-3xl mt-3">550</b></div>
            <div className="p-6 bg-white text-gray-700 rounded-lg shadow-md border border-gray-200">Weekly Mining <b className="block text-3xl mt-3">12,000</b></div>
            <div className="p-6 bg-white text-gray-700 rounded-lg shadow-md border border-gray-200">Monthly Mining <b className="block text-3xl mt-3">215,000</b></div>
          </div> */}

          <UserChartPage />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
